import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BookBasketOffer } from 'app/shared/models/class/basket/basketList';
import { FullOffer } from 'app/shared/models/class/offer/offer';
import { SessionBasketBookable } from 'app/shared/models/class/session-basket/session-basket';
import { BookSessionBasket, CreatePaymentSystemPay } from 'app/shared/models/class/systempay/systeme';
import { AuthService } from 'app/shared/services/auth/auth.service';
import { SessionBasketService } from 'app/shared/services/session-basket/session-basket.service';
import { SystempayService } from 'app/shared/services/systempay/systempay.service';
import { UiService } from 'app/shared/services/ui/ui.service';
import { CountryISO, PhoneNumberFormat, SearchCountryField } from 'ngx-intl-tel-input';
import KRGlue from '@lyracom/embedded-form-glue';
import { ThemePalette } from '@angular/material/core';
import { environment } from 'environments/environment';
import { PdfService } from 'app/shared/services/pdf/pdf.service';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';


interface DialogData {
  myOrder: BookBasketOffer;
  offers: FullOffer[];
  licences: FullOffer[];
}

@Component({
  selector: 'app-open-dialog-confirm-booked',
  templateUrl: './open-dialog-confirm-booked.component.html',
  styleUrls: ['./open-dialog-confirm-booked.component.scss']
})
export class OpenDialogConfirmBookedComponent implements OnInit {


  separateDialCode = false;
  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  PhoneNumberFormat = PhoneNumberFormat;
  preferredCountries: CountryISO[] = [CountryISO.UnitedStates, CountryISO.UnitedKingdom];
  phoneForm: UntypedFormGroup;

  confirmSubmit = false;
  promiseError = null;
  loading = false;
  bookingKey: any;
  amount = 0;
  isFullPayment = false;
  typePayment = null;
  color: ThemePalette = 'primary';
  payementActive = false;
  amountAdvance: number;
  amountAdvanceAndOnline: number;
  amountLicences: number;
  userKey: number;
  canPayToClub = false;
  cannotPayOnlyAdvance = false;
  hasToPayAdvanceAndOnline = false;
  hasToPayOnlyLicences = false;
  hasLicencesToPay = false;

  commentMaxLength = 500;
  commentForm: UntypedFormGroup;
  showComment = true;

  logoClub: string;

  constructor(
    public dialogRef: MatDialogRef<OpenDialogConfirmBookedComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private formBuilder: UntypedFormBuilder,
    private uiService: UiService,
    private sessionBasketService: SessionBasketService,
    private authService: AuthService,
    private systempayService: SystempayService,
    private pdfService: PdfService,
    private faIconService: FaiconService,
  ) { }

  ngOnInit(): void {
    this.initForm();
    this.initComponent();
  }

  onSubmit(sendPhoneNumber: boolean = true): void {
    this.data.myOrder.phoneNumberUser = !sendPhoneNumber ? '' : (this.f.phone.value?.e164Number || '');
    const { sub: userKey } = this.authService.getDecodedToken();
    if (sendPhoneNumber && !this.f.phone.value?.e164Number) {
      this.uiService.showSnackbar('Veuillez compléter le n° de téléphone');
    } else {

      this.sessionBasketService.checkSessionBasketBookable(+userKey).subscribe({
        next: res => {
          res.every((el: SessionBasketBookable) => el.isBookable) ?
            this.bookMyOrder() :
            this.uiService.showSnackbar('Une de vos sessions n\'est plus disponible');
        }
      });
    }
  }

  getImageClub() {
    this.sessionBasketService.getImageClub(this.userKey).subscribe((image) => {
      if (image) {
        this.logoClub = `data:image/png;base64,${image}`;
      } else {
        this.logoClub = "";
      }

    })
  }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  //TODO réservation
  bookMyOrder(): void {
    if (this.commentForm.value.comment) {
      this.data.myOrder.memoMessageUser = this.commentForm.value.comment;
    }

    this.sessionBasketService.bookOffer(this.data.myOrder).subscribe({
      next: res => {
        this.bookingKey = res;
        this.confirmSubmit = true;
      }
    });
  }

  getTypeOfPayment(event): void {
    this.typePayment = event.value;
    this.isFullPayment = this.typePayment === 'total';
  }

  gotToPayment(): void {
    this.payementActive = true;
    this.initPayment();
  }

  exportPdfBill(): void {
    this.pdfService.getPdfBookedSession(this.bookingKey).subscribe({
      next: blob => {
        const data = window.URL.createObjectURL(<any>blob.body);
        const anchor = document.createElement('a');
        const date = new Date();
        const time = date.getFullYear() + ('0' + (date.getMonth() + 1)).slice(-2) + ('0' + date.getDate()).slice(-2) + ('0' + date.getHours()).slice(-2) + ('0' + date.getMinutes()).slice(-2) + ('0' + date.getSeconds()).slice(-2);
        anchor.href = data;
        anchor.download = `NPHDF-${date.getFullYear()}-${this.bookingKey}-${time}.pdf`;
        anchor.click();

        setTimeout(() => {
          window.URL.revokeObjectURL(data);
        }, 100);
      }
    });
  }

  get f() {
    return this.phoneForm.controls;
  }

  private initPayment() {
    const bookSessionBasket = new BookSessionBasket(null);
    bookSessionBasket.userKey = this.data.myOrder.userKey;
    bookSessionBasket.offerKeys = this.data.myOrder.offerKeys;
    bookSessionBasket.bookedSessionWithPrice = this.data.myOrder.bookedSessionWithPrice;
    bookSessionBasket.bookingAmount = this.data.myOrder.bookingAmount;
    bookSessionBasket.phoneNumberUser = this.data.myOrder.phoneNumberUser;

    if (this.data.myOrder.promoCodeDiscount && this.data.myOrder.promoCodeName) {
      bookSessionBasket.promoCodeDiscount = this.data.myOrder.promoCodeDiscount;
      bookSessionBasket.promoCodeName = this.data.myOrder.promoCodeName;
    }

    if (this.commentForm.value.comment) {
      bookSessionBasket.memoMessageUser = this.commentForm.value.comment;
    }

    const payment = new CreatePaymentSystemPay(bookSessionBasket, this.isFullPayment);
    this.systempayService.creatPaymentSystemePay(payment).subscribe({
      next: (res: any) => {
        this.pay(res.formToken);
        this.bookingKey = res.bookingKey;
      },
      error: error => {
        this.dialogRef.close(this.bookingKey);

        this.uiService.showSnackbar('Une erreur est survenue');
      }
    });

  }

  private pay(token: any) {
    const endpoint = 'https://api.systempay.fr';
    const { idSystempay: publicKey } = environment;
    const formToken = token;


    KRGlue.loadLibrary(endpoint, publicKey) /* Load the remote library */
      .then(({ KR }) =>
        KR.setFormConfig({
          /* set the minimal configuration */
          formToken,
          'kr-language': 'fr-FR' /* to update initialization parameter */
        })
      )
      .then(({ KR }) => KR.button.onClick(() => {
        this.loading = true;
      }))
      .then(({ KR }) => KR.onError((error) => {
        console.error("error", error);
        if (error.errorCode === "PSP_113") {
          this.loading = true;
        } else {
          this.loading = false;
        }
      }))
      .then(({ KR }) => KR.on3dSecureAbort(() => {
        this.loading = false;
      }))
      .then(({ KR }) => KR.onSubmit(resp => {
        if (resp.clientAnswer.orderStatus === 'PAID') {
          // Remove the payment form
          this.confirmSubmit = true;
          this.loading = false;
        } else {
          // Show error message to the user
          alert('Payment failed !');
          this.loading = false;
        }

        // return false
      }))
      .then(({ KR }) =>
        KR.addForm('#myPaymentForm')
      ) /* add a payment form  to myPaymentForm div*/
      .then(({ KR, result }) => {
        KR.showForm(result.formId);
        // this.loading = false;
      }
      ) /* show the payment form */
      .catch(
        error => (this.promiseError = error + ' (see console for more details)')
      );
  }

  private initComponent(): void {
    this.userKey = +this.authService.getDecodedToken().sub;

    this.getImageClub();

    this.getAmountWithAdvance();
    this.getAmountToPay();
    if (this.data.offers.every((offer) => offer.isPayableAtClub === true && offer.advancePayment === 0)) {
      this.canPayToClub = true;
    }

    if (this.data.offers.filter(o => o.advancePayment > 0).length > 0 && this.data.offers.filter(o => o.isPayableOnline && !o.isPayableAtClub).length > 0 && this.data.offers.filter(o => o.advancePayment > 0).length !== this.data.offers.length) {
      this.hasToPayAdvanceAndOnline = true;
      this.getAmountAdvanceAndOnline();
    } else if (this.data.offers.filter(o => o.advancePayment > 0).length === 0 && this.data.offers.filter(o => o.isPayableOnline && !o.isPayableAtClub && !o.isLicence).length === 0 && this.data.offers.filter(o => o.isPayableAtClub).length > 0 && this.data.offers.filter(o => o.isLicence).length > 0 && this.data.offers.filter(o => o.isPayableOnline).length === 0) {
      this.hasToPayOnlyLicences = true;
      this.getAmountLicences();
    } else if (this.data.offers.filter(o => o.isLicence).length > 0 && this.data.offers.filter(o => o.isPayableAtClub).length > 0) {
      this.hasLicencesToPay = true;
      this.getAmountLicences();
    }
    // this.typePayment = this.amountAdvance !== this.data.myOrder.bookingAmount ? 'advance' : 'total';

    if (this.amountAdvance > 0) {
      this.compareAmountAndAdvance();
    }

    if (this.amountAdvanceAndOnline > 0) {
      this.compareAmountAndAdvanceOnline();
    }

    if (this.amountLicences > 0) {
      this.compareAmountAndLicences();
    }
  }

  // réservation si le montant est à 0
  checkAmount() {
    if (this.amount === 0) {
      this.sessionBasketService.checkSessionBasketBookable(this.userKey).subscribe({
        next: res => {
          res.every((el: SessionBasketBookable) => el.isBookable) ?
            this.bookMyOrder() :
            this.uiService.showSnackbar('Une de vos sessions n\'est plus disponible');
        }
      });
    }
  }

  private getAmountToPay(): void {
    this.amount = 0;
    for (const [i, o] of this.data.offers.entries()) {
      if (o.isPayableOnline) {
        this.amount +=
          this.isFullPayment ?
            this.data.myOrder.bookingAmount
            : (this.data.myOrder.bookedSessionWithPrice[i]?.sessionTotalPrice || 0);
      }
    }

    if (this.amount > 0 && this.data.myOrder.promoCodeDiscount && this.data.myOrder.promoCodeName) {
      this.amount -= this.data.myOrder.promoCodeDiscount;
      if (this.amount <= 0) {
        this.amount = 0;
      }
    }
  }

  private getAmountWithAdvance(): void {
    this.amountAdvance = 0;
    for (const [i, o] of this.data.offers.entries()) {
      // if (o.isPayableOnline) {
      this.amountAdvance +=
        o.advancePayment === 0 ?
          // this.data.myOrder.bookedSessionWithPrice[i]?.sessionTotalPrice || 0 : o.advancePayment * o.traineeQuantity;
          0 : o.advancePayment * o.traineeQuantity;
      // }
    }
  }

  private getAmountAdvanceAndOnline(): void {
    this.amountAdvanceAndOnline = 0;
    for (const [i, o] of this.data.offers.entries()) {
      if (o.isPayableOnline && o.isPayableAtClub) {
        this.amountAdvanceAndOnline +=
          o.advancePayment === 0 ?
            0 : o.advancePayment * o.traineeQuantity;
      } else if (o.isPayableOnline && !o.isPayableAtClub) {
        this.amountAdvanceAndOnline += this.data.myOrder.bookedSessionWithPrice[i]?.sessionTotalPrice;
      }
    }


  }

  private getAmountLicences(): void {
    this.amountLicences = 0;
    for (const [i, o] of this.data.offers.entries()) {
      if (o.isLicence) {
        this.amountLicences += o.fixedPrice;
      }
    }
  }

  private compareAmountAndAdvance(): void {
    if (this.amount <= this.amountAdvance) {
      this.amountAdvance = 0;
    }
  }

  private compareAmountAndAdvanceOnline(): void {
    if (this.amount <= this.amountAdvanceAndOnline) {
      this.amountAdvanceAndOnline = 0;
    }
  }

  private compareAmountAndLicences(): void {
    if (this.amount <= this.amountLicences) {
      this.amountLicences = 0;
    }
  }

  private initForm(): void {
    // this.phoneForm = this.formBuilder.group({
    //   phone: ['', Validators.required]
    // });

    this.commentForm = this.formBuilder.group({
      comment: ['', Validators.maxLength(this.commentMaxLength)]
    });
  }

  // TODO réservation au club
  confirmBook() {
    this.sessionBasketService.checkSessionBasketBookable(this.userKey).subscribe({
      next: res => {
        res.every((el: SessionBasketBookable) => el.isBookable) ?
          this.bookMyOrder() :
          this.uiService.showSnackbar('Une de vos sessions n\'est plus disponible');
      }
    });
  }

}
